import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { isAuthUpgradeNavigationPending } from '../../utils/authUpgradeNavigation';

/**
 * Warns guests before the tab closes, from any page: a guest account only
 * lives in this browser, so leaving can lose the simulated match history.
 * Suppressed while a signup-gate OAuth upgrade redirect is in flight, since
 * that navigation is exactly how the guest keeps their progress.
 */
function GuestLeaveWarning() {
    const { isGuest: authIsGuest, user } = useAuth();
    const isGuest = authIsGuest === true || user?.isGuest === true;

    useEffect(() => {
        if (!isGuest) {
            return undefined;
        }

        const warnBeforeLeaving = (event) => {
            if (isAuthUpgradeNavigationPending()) {
                return undefined;
            }
            event.preventDefault();
            event.returnValue = '';
            return '';
        };

        window.addEventListener('beforeunload', warnBeforeLeaving);
        return () => window.removeEventListener('beforeunload', warnBeforeLeaving);
    }, [isGuest]);

    return null;
}

export { GuestLeaveWarning };
